// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-header {
    height: 320px;
    position: relative;
    width: 100%;
}

.check-border-not {
    width: 100%;
    border: 1px solid #000;
    border-radius: 10px;
    height: 240px;
}

.company-wrapper {
    display: inline-block;
    font-size: 95%;
}

.bank-wrapper {
    top: 0px;
    margin-left: 120px;
    font-size: 95%;
    display: inline-block;
}

.check-number {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 120%;
}

.check-amount {
    position: absolute;
    top: 100px;
    right: 0px;
    /*top: {{this.vm.printLayout.checkStock.payment_amount_top}}px;
    right: {{this.vm.printLayout.checkStock.payment_amount_right}}px;*/
}

.stub {
    width: 100%;
    height: 330px;
    overflow: hidden;
}

.check-stub-table {
    font-size: 70%;
    width: 24%;
    float: left;
    margin-right: 5px;
    font-weight: normal;
}

.check-stub-table th {
    border-bottom: 2px solid #000;
    padding: 2px;
}

.check-stub-table td {
    border-bottom: 1px solid #000;
    padding: 1px;
}

.pay {
    position: absolute;
    top: 110px;
    left: 0px;
    font-size: 90%;
}

.to-order {
    position: absolute;
    top: 140px;
    left: 0px;
}

.payee {
    position: absolute;
}

.print-payment-receipt-table {
    margin: 30px auto 0 auto;
    width: 100%;
}

.print-payment-receipt-table th {
    padding: 4px;
    border-bottom: 2px solid #000;
}

.print-payment-receipt-table td {
    padding: 4px;
    border-bottom: 1px solid #000;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
